import React, { type FC } from 'react'
import { Flex } from 'antd'
import { CheckmarkCircle16Filled, DismissCircle16Filled } from '@fluentui/react-icons'
import { formatCapitalizedString, useMSTheme } from '@choreograph/layout'

interface IBooleanLabelIconProps {
  value: boolean
  showLabel?: boolean
}

export const BooleanLabelIcon: FC<IBooleanLabelIconProps> = ({ value, showLabel = true }) => {
  const theme = useMSTheme()
  const errorRedColor = theme.data.color.danger[500]
  const successGreenColor = theme.data.color.success[400]

  return (
    <Flex align='center'>
      {
        value
          ? <CheckmarkCircle16Filled color={successGreenColor} />
          : <DismissCircle16Filled color={errorRedColor} />
      }
      {
        showLabel && (
          <>
            &nbsp;
            {formatCapitalizedString(String(value))}
          </>
        )
      }

    </Flex>
  )
}
